module.exports = __webpack_public_path__ + "static/media/ax.12491ab5.svg";